import React from "react"
import cn from "classnames"
import { transcode } from "buffer"
import "./PageContainer.scss"

interface IPageContainerProps {
    title?: string
    id?: string
    transparent?: boolean
    noHeader?: boolean
    centerContent?: boolean
    roundPageLook?: boolean
    largeText?: boolean
    classNameBody?: string
    topBottomMargin?: boolean
    children?: React.ReactNode
}

const PageContainer = ({
    children,
    centerContent,
    roundPageLook,
    noHeader,
    title,
    id,
    transparent,
    classNameBody,
    largeText,
    topBottomMargin,
}: IPageContainerProps) => {
    return (
        <div className={cn("swiipe-page-container page", roundPageLook && "mt-5")} id={id}>
            {!noHeader && (
                <div className="page-header mb-1">
                    <span className="d-block d-sm-none text-uppercase text-smaller font-weight-light">{title} </span>
                </div>
            )}
            <div
                className={cn(
                    "page-body",
                    roundPageLook && "rounded px-3",
                    topBottomMargin && "py-5",
                    { transparent, "large-text": largeText },
                    classNameBody
                )}
            >
                <div className={cn(centerContent && "justify-content-center center-content")}>{children}</div>
            </div>
        </div>
    )
}

export default PageContainer
